// Auth Handlers
export var AUTH_TOKEN_COOKIE_NAME = "CAT";
export var AUTH_TOKEN_EXPIRY_COOKIE_NAME = "CAT_EXP";
export var AUTH_FLOW_TOGGLE_COOKIE_NAME = "auth_v3";
export var PHP_SESSION_COOKIE = "PHPSESSID";
export var AUTH_COOKIE_EXPIRY_IN_HOURS = 1; // Blocked Account Page

export var CATCH_LOGO_URL = "https://s.catch.com.au/static/catch/images/logo-83d9b21199.svg";
export var TERMS_AND_CONDITIONS_URL = "/terms";
export var CUSTOMER_SUPPORT_URL = "https://help.catch.com.au/s/articles?&catName=My_Account";
export var BLOCKED_ACCOUNT_TEXT_FRAGMENT = "blocked";
export var BLOCKED_ACCOUNT_PAGE_PATH = "/account-blocked"; // New Flow - Auth endpoints

export var REFRESH_TOKEN_ENDPOINT = "/auth/refresh";
export var LOGIN_ENDPOINT = "/auth/login";
export var LOGOUT_ENDPOINT = "/auth/logout";